
import { defineComponent } from "vue";
export default defineComponent({
	name: "imdex-toast",
	props: {
		type: {
			type: String,
			default: "primary"
		},
		delay: {
			type: Number,
			default: 5000
		},
		dismissable: {
			type: Boolean,
			default: false
		},
		message: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		},
		leadingIcon: {
			type: String,
			default: ""
		},
		position: {
			type: String,
			default: "top-right"
		}
	},
	data() {
		return {
			progress: 0,
			destroyed: false
		};
	},
	mounted() {
		const prog = this.$refs.progress as any;
		prog.style.transition = `width ${this.delay / 1000}s linear`;
		prog.style.width = "0%";

		setTimeout(() => {
			// Since it is possible to dismiss which calls destroy
			// we check if destroyed has already been called
			if (!this.destroyed) {
				this.destroy();
			}
		}, this.delay);
		setTimeout(() => {
			this.progress = 1;
			prog.style.width = "100%";
		}, 50);
	},
	methods: {
		destroy() {
			const body: any = document.getElementById("toast-container");
			this.$el.classList.add("fadeOutDown");

			setTimeout(() => {
				if (body && this.$el && body.contains(this.$el)) {
					body.removeChild(this.$el);
					this.destroyed = true;
				}
			}, 300);
		}
	},
	computed: {
		icon() {
			if (this.leadingIcon != "") {
				return this.leadingIcon;
			} else {
				if (this.type == "success") {
					return "fal fa-check";
				}
				if (this.type == "error") {
					return "fal fa-exclamation-circle";
				}
				if (this.type == "warning") {
					return "fal fa-exclamation-triangle";
				}
				if (this.type == "primary") {
					return "fa fa-info-circle";
				}
				return "";
			}
		}
	}
});
